const initializeCompanies = () => [
  { id: 1, name: 'all' },
  { id: 2, name: 'wizeline' },
  { id: 3, name: 'gravity' },
];

export default {
  initializeCompanies,
};



// WEBPACK FOOTER //
// ./store/modules/companies/actions.js